import "./App.css";
import NiceForm from "./components/niceform";
import CardList from "./components/cardlist";
import { useState } from "react";
function App() {
  const [cards, setCards] = useState([]);

  const addNewCard = (cardInfo) => {
    setCards(cards.concat(cardInfo));
  };

  return (
    <div>
      <NiceForm onSubmit={addNewCard} />
      <CardList cards={cards} />
    </div>
  );
}

export default App;
